import React, { useEffect } from 'react';
import styles from './BoxColumnTariff.module.scss';
import CustomItem from '../CustomItem/CustomItem';
import { Form } from 'antd';
import DropdownSelect from '../../../../../../../components/dropdownSelect/DropdownSelect';
import { nameTableColumn } from '../../../constants/nameTableRso';
import useTariffValuesSelect from '../../../hooks/useTariffValuesSelect';
import useSelectedValuesTariffColumn from '../../../hooks/useSelectedValuesTariffColumn';
import { getRenderControl } from '../../../../../../../components/SingleControlCustom/getRenderControl';
import { useSelector } from 'react-redux';

const FormDropdownSelect = ({
  form,
  label,
  fieldName,
  getOptions,
  onChangeSelect,
  visibleSelect,
}) => {
  const { getFieldDecorator, getFieldValue, setFieldsValue } = form;

  const { valueForm } = useSelector((state) => state.rsoImportStore);

  const options = getOptions(fieldName);

  const getInitialValue = () => {
    if (valueForm?.meterTriffs && valueForm?.meterTriffs.length) {
      if (fieldName === nameTableColumn.MeterTriffs_One) {
        return Number(valueForm.meterTriffs[0]);
      }

      if (fieldName === nameTableColumn.MeterTriffs_Two) {
        return Number(valueForm.meterTriffs[valueForm.meterTriffs.length - 1]);
      }
    }

    return undefined;
  };

  return (
    <Form.Item
      label={label}
      labelCol={{ span: 13, style: { textAlign: 'left' } }}
      wrapperCol={{ span: 11 }}
      className={styles.formItem}
    >
      {getFieldDecorator(fieldName, {
        initialValue: getInitialValue(),
        rules: [
          {
            required: visibleSelect ? true : false,
            message: 'Пожалуйста, выберите название тарифа',
          },
        ],
      })(
        <DropdownSelect
          options={options}
          onChange={(val) => onChangeSelect(fieldName, val)}
          multiple={false}
          renderControl={getRenderControl({
            options: options,
            isClear: true,
            value: getFieldValue(fieldName),
            onClearClick: () => {
              setFieldsValue({ [fieldName]: undefined });
            },
          })}
        />
      )}
    </Form.Item>
  );
};

const BoxColumnTariff = ({
  form,
  highlightColor,
  getOptionsColumnForSelect,
  onChangeColumnItem,
}) => {
  const { getFieldValue } = form;

  const { columnLabels } = useSelector((state) => state.rsoImportStore);

  const columnTariffValue = getFieldValue(nameTableColumn.columnTariff);

  const { tariffValues, changeTariffValues } = useTariffValuesSelect();
  const { handleSelectChangeTariffColumn, getOptionsTariffColumnForSelect } =
    useSelectedValuesTariffColumn(tariffValues);

  const visibleSelect =
    tariffValues && tariffValues.length > 1 && columnTariffValue;
  const hasTwoTariffCountersValue = getFieldValue('hasTwoTariffCounters');

  useEffect(() => {
    if (columnTariffValue) {
      const found = columnLabels?.find(
        (item) => item.value === columnTariffValue
      );

      changeTariffValues(found.id);
    }
  }, [columnTariffValue, changeTariffValues, columnLabels]);

  return (
    <div
      className={styles.root}
      style={{ display: hasTwoTariffCountersValue ? 'flex' : 'none' }}
    >
      <CustomItem
        form={form}
        highlightColor={highlightColor}
        options={getOptionsColumnForSelect}
        fieldName={nameTableColumn.columnTariff}
        label="Столбец столбец с тарифами"
        requiredMessage={
          hasTwoTariffCountersValue
            ? 'Пожалуйста, выберите столбец столбец с тарифами'
            : null
        }
        onChange={onChangeColumnItem}
        isClear={true}
      />
      <div
        className={styles.containerTarrifs}
        style={{ display: visibleSelect ? 'flex' : 'none' }}
      >
        <FormDropdownSelect
          form={form}
          label="Название дневного тарифа электроэнергии"
          fieldName={nameTableColumn.MeterTriffs_One}
          getOptions={getOptionsTariffColumnForSelect}
          onChangeSelect={handleSelectChangeTariffColumn}
          visibleSelect={visibleSelect}
        />
        <FormDropdownSelect
          form={form}
          label="Название ночного тарифа электроэнергии"
          fieldName={nameTableColumn.MeterTriffs_Two}
          getOptions={getOptionsTariffColumnForSelect}
          onChangeSelect={handleSelectChangeTariffColumn}
          visibleSelect={visibleSelect}
        />
      </div>
    </div>
  );
};

export default BoxColumnTariff;
